import { Injectable, Type } from '@angular/core';

import { BasicObject, Product, QuoteContextModel } from '@bytel/bytel-sales';
import { CartCheckoutService, CheckoutCartModel, QuoteContextFactory } from '@bytel/checkout';

import { Observable, map, mergeMap, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProviderCheckoutService {
    private cartModel: CheckoutCartModel;

    constructor(
        private cartCheckoutService: CartCheckoutService,
        private quoteContextFactory: QuoteContextFactory,
    ) {
        this.cartModel = new CheckoutCartModel();
        this.cartCheckoutService.initCart(this.cartModel);
    }

    public addProduct(planId: string, optionIds: string[] = [], quoteIndex?: number): Observable<Product[]> {
        return this.cartCheckoutService.addProductsByGencodes(this.cartModel, [planId, ...optionIds], quoteIndex);
    }

    public initQuote<T extends QuoteContextModel>(contextType: Type<T>, params: BasicObject = {}): Observable<number> {
        const contextModel: QuoteContextModel = new contextType();
        const currentQuoteIndex: number = this.cartModel.quotes.findIndex(
            (quote) => quote.context.id === contextModel.id,
        );

        return (
            currentQuoteIndex > -1
                ? this.cartCheckoutService.removeQuote(this.cartModel, currentQuoteIndex)
                : of(void 0)
        ).pipe(
            mergeMap(() => this.quoteContextFactory.createContext<T>(contextType, params)),
            map((context) => {
                this.cartCheckoutService.addQuote(this.cartModel, context);
                return this.cartModel.quotes.findIndex((quote) => quote.context.id === contextModel.id);
            }),
        );
    }
}
